import React from "react";


function Doctor() {
return (
<section id="doctor" className="doctor">
<h2>Meet Our Doctor</h2>
<p>
Dr. Aniket Sharma (BDS, MDS) – An experienced dental surgeon specializing in
orthodontics and implants. Passionate about delivering care with empathy.
</p>
</section>
);
}


export default Doctor;